module.exports = __webpack_public_path__ + "static/media/vf_wpants_core.0600954b.svg";